
































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator'; // デコレータ
import { Constants } from '../fixed/Constants';

@Component
export default class VariableDatePicker extends Vue {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  // カレンダーから受け取る値(date)
  private date: string = '';
  // テキストフィールド内に表示する値(formatted)
  private formatted: string = '';
  private pickerVisible: boolean = false;
  private privateInvaildMessage: string = '';
  private innerLabel: string = '';
  private rules: any;
  private clearable: boolean = false;
  private counter: string | boolean = false;
  private solo: boolean = false;
  private privateTextColor: string = '';
  private wareki: string = '';
  // prop定義
  @Prop({default: false}) private isGroup?: boolean;
  @Prop() private grouplabel?: string;
  @Prop() private groupLayout?: string;
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop() private label?: string;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
  @Prop({default: false}) private required?: boolean;
  @Prop() private prefix?: string;
  @Prop() private suffix?: string;
  @Prop() private placeholder?: string;
  @Prop() private hint?: string;
  @Prop() private size?: string;
  @Prop() private maxlength?: string;
  @Prop() private minlength?: string;
  @Prop() private pattern?: string;
  @Prop() private invaildMessage?: string;
  @Prop() private textColor?: string;
  private created() {
    // 確認画面表示のdefault文字色設定
    if (!this.textColor) {
      this.privateTextColor = 'black--text';
    } else {
      this.privateTextColor = this.textColor;
    }
    // ラベルの設定
    if (this.isGroup && this.label && this.groupLayout !== Constants.GROUP_LAYOUT_ARRAY) {
      this.innerLabel = this.label;
    }
    // クリアボタンの設定
    this.clearable = !(this.readonly || this.disabled);
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    // 親コンポーネントから受け取った値の表示
    if (this.value !==  undefined && this.value !== '') {
      this.formatted = this.formatDate(this.value.substr(0, 10));
      this.date = this.value;
      this.formatDateWareki(this.date);
    }
    // validationルールの設定
    this.rules = [
      (value: string) => (this.isValidateRequired(value)) || '必須項目です。',
      (value: string) => (this.isValidate(value)) || this.privateInvaildMessage,
      ];
  }
  /**
   * 年月日のフォーマット
   * YYYY-MM-DD　→　YYYY/MM/DDに変更する
   * @param date 年月日(YYYY-MM-DD)
   * @returns 年月日(YYYY/MM/DD)
   */
  private formatDate(date: string) {
    if (!date) {
      return '';
    }
    const [year, month, day] = date.split('-');
    if (month === undefined) {
      return date;
    }
    return `${year}/${month}/${day}`;
  }
  /**
   * 年月日のフォーマット
   * YYYY-MM-DD　→　GGYY年MM月DD日変更する
   * @param date 年月日(YYYY-MM-DD)
   * @returns 年月日(YYYY/MM/DD)
   */
  private formatDateWareki(date: string) {
    if (!date) {
      this.wareki = '';
      return ;
    }
    if (date !==  undefined && date !== '') {
      const [year, month, day] = date.split('-');
      const sdate = new Date(Number(year), Number(month) - 1, Number(day));
      const options = {year: 'numeric', month: 'long', day: 'numeric', era: 'long'};
      this.wareki = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', options).format(sdate);
    } else {
      this.wareki = '';
    }
  }
  /**
   * 年月日のフォーマット
   * YYYY/MM/DD　→　YYYY-MM-DDに変更する
   * @param date 年月日(YYYY/MM/DD)
   * @returns 年月日(YYYY-MM-DD)
   */
  private parseDate(date: string) {
    if (!date) {
      return '';
    }
    if (!this.isValidate(date)) {
      return '';
    }
    const [year, month, day] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  // emit定義
  @Emit('input')
  private updateValue(value: string) {
    return value;
  }
  // 親側でvalueのみ変更された場合のため
  @Watch('value')
  private onChangeValue(value: string) {
    if (value !==  undefined && value !== '') {
      this.formatted = this.formatDate(value.substr(0, 10));
      this.date = value;
    } else {
      this.wareki = '';
      this.date = '';
    }
  }
  /**
   * 年月日情報のウォッチ
   * カレンダーから日付が選択されたとき、
   * フィールド内にフォーマットした年月日を表示
   */
  @Watch('date')
  private onCahngeDate(val: string) {
    if (!val) {
      return;
    }
    this.formatted = this.formatDate(val);
    this.formatDateWareki(val);
  }
  // validationの設定
  private isValidateRequired(value: string) {
    return this.validate.isValidateRequired(value, this.required);
  }
  private isValidate(value: string) {
    if (!this.validate.isValidate(value, this.maxlength, this.minlength, this.pattern)) {
      return false;
    }
    if (!value) {
      return true;
    }
    const [year, month, day] = value.split('/');
    return Number(month) - 1 === new Date(Number(year), Number(month) - 1, Number(day)).getMonth();
  }
}
